// extracted by mini-css-extract-plugin
export default {"txhash":"styles_txhash__NLMC3"};